module.exports = __webpack_public_path__ + "media/application/images/ui/tick-top-brand-51b2ac8d49c6b20d0addce44f5a4fabd.svg";